import { Box } from '@mui/material';

const FullScreenBox = ({ children, ...rest }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      {...rest}
    >
      {children}
    </Box>
  );
};

export default FullScreenBox;
